import { DialogTitle, DialogTitleProps, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { FC } from 'react';

type Props = {
  title: string;
  icon?: JSX.Element;
  onClose?: () => void;
} & DialogTitleProps;

export const InformationDialogTitle: FC<Props> = ({ title, icon, onClose }) => {
  return (
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }}
    >
      {icon}
      <Typography variant="h3" component="span" flexGrow={1}>
        {title}
      </Typography>
      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          disableRipple
          sx={{
            padding: 0,
            '&:hover': {
              '& svg': {
                color: 'grey.900'
              }
            }
          }}
        >
          <CloseIcon sx={{ fontSize: '1rem' }} color="primary" />
        </IconButton>
      )}
    </DialogTitle>
  );
};
